import axios from 'axios';
import store from '../store';
export default {
  namespaced: true,

  state: {
    idmodal: '',
    descripcionmodal: '',
    banderamodal: null,
    pedidos: [],
    pedido: [],
    detalle: [],
    transportistas: [],
    idttransportista: [],
    idpedido: [],
    despachados: [],
    transporte: [],
    guiaa: [],
    bandera: true,
    len: [],
    mostrarmodal: [],
    len2: false




  },
  mutations: {


    datosmodal(state, api) {
      state.detalle = api.detallepedido

    },

    async cargardatostransportistasreal(state, data) {
      state.pedido = []
      var data1 = data.data1;
      var data2 = data.data2;
      var data3 = state.idpedido
      var token = store.state.numero;
      await axios
        .get("https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/Encpedidos/Despachopedido/" + data3 + "/" + data1 + '/' + data2, {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        })
        .then((response) => {
          state.pedidos = response.data;
        })
        .catch((e) => {
          console.log(e);
        })

      state.pedido = state.pedidos
    },


    async cargardatostransportistas(state, api) {

      state.despachados = []
      state.transportistas = []
      var token = store.state.numero;
      await axios
        .get("https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/Transportista", {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        })
        .then((response) => {
          state.transportistas = response.data.data;

        })
        .catch((e) => {
          console.log(e);
          location.reload()
        })
      if (api) {

        state.despachados = api.despachado
        state.idpedido = api.idpedido
        state.transporte = api.nombreTransportista
        state.guiaa = api.guia

      }


    },


    async cargardatospendientes(state) {

      state.pedido = []
      state.pedidos = []
      var token = store.state.numero;


      await axios
        .get("https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/Encpedidos/GetPedidosPendientes", {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        })
        .then((response) => {
          state.pedidos = response.data;
          console.log(response.data.length)
          if (response.data.length === 0) {
            state.len2 = true
          }
          else {
            state.len2 = false
          }


        }).catch((e) => {
          console.log(e);
          location.reload()
        });
      state.pedido = state.pedidos
    },


    async cargardatosfecha(state, api) {

      state.pedido = []
      var token = store.state.numero;
      let data1 = api.data1
      let data2 = api.data2
      await axios
        .get("https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/Encpedidos/getpedidosfechasp/" + data1 + '/' + data2, {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        })
        .then((response) => {
          state.pedidos = response.data;

          state.len = response.data.length

        }).catch((e) => {
          console.log(e);



        });

      state.pedido = state.pedidos
    },



    /*async cargardatospedidos(state) {

      state.pedido = []
      var token = store.state.numero;


      await axios
        .get("https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/Encpedidos", {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        })
        .then((response) => {
          state.pedidos = response.data.data;


        }).catch((e) => {
          console.log(e);
          location.reload()
        });
      state.pedido = state.pedidos
    },
*/

    detallepedidos(state, api) {

      var token = store.state.numero
      let idmodal = api.idpedido;
      axios
        .get("https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/Encpedidos/GetDetallePedidoPorId/" + idmodal,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + token,
            },
          })
        .then((response) => {
          let tokenn = response.data;
          state.len = response.data.length
          state.detalle = tokenn
          setTimeout(() => {

            if (state.len === 0) {


              state.mostrarmodal = false

            }
            else {
              state.mostrarmodal = true

            }
          }, 50);



        })
        .catch((e) => {
          console.log(e);
          location.reload()
        })
    }
  },
  actions: {

  },
  getters: {


  },






}